if (!customElements.get('recharge-subscription-widget')) {
  customElements.define(
    'recharge-subscription-widget',
    class RechargeSubscriptionWidget extends HTMLElement {
      connectedCallback() {
        this.prices = this.readPrices();
        this.section = this.closest('section') || document.getElementById(`MainProduct-${this.dataset.section}`);
        this.onPurchaseChange = this.onPurchaseChange.bind(this);
        this.onPlanChange = this.onPlanChange.bind(this);
        this.onVariantChange = this.onVariantChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onInfoClick = this.onInfoClick.bind(this);

        this.querySelectorAll('[data-rc-purchase]').forEach((input) => {
          input.addEventListener('change', this.onPurchaseChange);
        });
        this.querySelector('[data-rc-plan]')?.addEventListener('change', this.onPlanChange);
        this.querySelector('.rc-sub-widget__info')?.addEventListener('click', this.onInfoClick);
        this.section?.addEventListener('change', this.onVariantChange);
        this.section?.addEventListener('submit', this.onSubmit, true);

        this.querySelectorAll('[data-rc-option]').forEach((option) => {
          option.addEventListener('click', (event) => {
            if (event.target.closest('select, button, a, label, input')) return;
            const radio = option.querySelector('[data-rc-purchase]');
            if (!radio || radio.checked) return;
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });

        this.sync();
      }

      disconnectedCallback() {
        this.section?.removeEventListener('change', this.onVariantChange);
        this.section?.removeEventListener('submit', this.onSubmit, true);
      }

      readPrices() {
        const node = this.querySelector('[data-rc-prices]');
        if (!node) return {};
        try {
          return JSON.parse(node.textContent);
        } catch (error) {
          console.error(error);
          return {};
        }
      }

      currentVariantId() {
        const input = this.section?.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
        return input?.value || this.dataset.variantId;
      }

      selectedPlanId() {
        const purchase = this.querySelector('[data-rc-purchase]:checked');
        if (!purchase || purchase.value !== 'subscribe') return '';
        return this.querySelector('[data-rc-plan]')?.value || '';
      }

      onPurchaseChange() {
        this.updateSelectedState();
        this.updatePrices();
        this.syncForms();
      }

      onPlanChange() {
        this.updatePrices();
        this.syncForms();
      }

      onVariantChange(event) {
        if (!event.target.matches('input[name="id"], .product-variant-id')) return;
        this.dataset.variantId = event.target.value;
        this.updatePrices();
      }

      onSubmit(event) {
        if (!event.target.matches('form[data-type="add-to-cart-form"]')) return;
        this.syncForms();
      }

      onInfoClick(event) {
        const button = event.currentTarget;
        button.classList.toggle('is-open');
      }

      updateSelectedState() {
        const selected = this.querySelector('[data-rc-purchase]:checked')?.value;
        this.querySelectorAll('[data-rc-option]').forEach((option) => {
          option.classList.toggle('is-selected', option.dataset.rcOption === selected);
        });
      }

      updatePrices() {
        const variant = this.prices[this.currentVariantId()];
        if (!variant) return;

        const onetime = this.querySelector('[data-rc-onetime-price]');
        if (onetime) onetime.textContent = variant.onetime;

        const planId = this.querySelector('[data-rc-plan]')?.value;
        const plan = planId && variant.plans ? variant.plans[planId] : null;
        const subscribe = this.querySelector('[data-rc-subscribe-price]');
        const compare = this.querySelector('[data-rc-compare]');
        if (subscribe && plan) subscribe.textContent = plan.price;
        if (compare) {
          compare.textContent = plan?.compare || variant.onetime;
          compare.hidden = !plan?.showCompare;
        }
      }

      sync() {
        this.updateSelectedState();
        this.updatePrices();
        this.syncForms();
      }

      syncForms() {
        if (!this.section) return;
        const planId = this.selectedPlanId();
        this.section.querySelectorAll('form[data-type="add-to-cart-form"]').forEach((form) => {
          let input = form.querySelector('input[name="selling_plan"][data-rc-selling-plan]');
          if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'selling_plan';
            input.setAttribute('data-rc-selling-plan', '');
            form.appendChild(input);
          }
          input.value = planId;
          input.disabled = planId === '';
        });
      }
    }
  );
}
